define("SDB.PLP.Modifications.EntryPoint", [
  "SDB.SelectWheelsOrTires.SS2Model",
], function (SDBSelectWheelsOrTiresSS2Model) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      /** @type {PLPComponent} */
      var PLP = container.getComponent("PLP");
      var wheelsTiresModel = SDBSelectWheelsOrTiresSS2Model.getInstance();
      if (!PLP) return;

      var setWheelsOrTiresFlag = function setWheelsOrTiresFlag(e) {
        var $target = $(e.target).closest("a");
        var action = $target.data("action");
        var isSelectedTires = !!(action === "Tires");

        var cookies = wheelsTiresModel.getCookieOptions();
        var cookiesObject = {};
        if (cookies && cookies.length > 1) {
          cookiesObject = _.reduce(
            cookies,
            function (acc, item) {
              var trimmed = item.replace(/^\s+|\s+$/g, "");
              var parts = trimmed.split("=");
              var key = parts[0];
              var value = parts.slice(1).join("=");
              acc[key] = value;
              return acc;
            },
            {}
          );
        }
        cookiesObject.isSelectedTires = isSelectedTires;
        wheelsTiresModel.setCookieOptions(cookiesObject);
      };

      PLP.addToViewEventsDefinition(
        "Header.Menu.View",
        'click [data-action="Tires"]',
        setWheelsOrTiresFlag
      );
      PLP.addToViewEventsDefinition(
        "Header.Menu.View",
        'click [data-action="Wheels"]',
        setWheelsOrTiresFlag
      );
    },
  };
});
